module.exports = __webpack_public_path__ + "media/banners/otomoto-baner-fe97dcb9.png";